import React from 'react';

export const Trashcan = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 10.889 14">
            <path d="M.778 12.444A1.56 1.56 0 0 0 2.333 14h6.223a1.56 1.56 0 0 0 1.556-1.556V3.111H.778Zm2.465-4.985a.775.775 0 0 1 1.1-1.1l1.1 1.1 1.1-1.1a.775.775 0 0 1 1.1 1.1l-1.1 1.1 1.1 1.1a.775.775 0 0 1-1.1 1.1l-1.1-1.1-1.1 1.1a.775.775 0 0 1-1.1-1.1l1.1-1.1ZM10.111.778H8.167L7.614.226A.785.785 0 0 0 7.07 0H3.819a.785.785 0 0 0-.544.226l-.553.552H.778a.778.778 0 1 0 0 1.556h9.333a.778.778 0 1 0 0-1.556Z" />
        </svg>
    );
}
